import type { DeepPartial } from '@luna/utils-ts';

import type { ContactDataManagementFeatureConfig } from './type';

export const contactDataManagement: DeepPartial<ContactDataManagementFeatureConfig> = {
    address: {
        maxStreetLength: 30,
        poBoxType: true,
        streetNumberField: true,
    },
    changeNotEditableContactMessengerTopicId: 'ALLG',
    mainContactSetting: true,
};
